import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import { toast, Flip } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import api from '@utils/axiosInstance';

function DeleteSubtitleModal({
    deleteDialogOpen,
    setDeleteDialogOpen,
    languageToDelete,
    setLanguageToDelete,
    availableSubtitleLanguages,
    setAvailableSubtitleLanguages,
    currentSelectedLanguage,
    setCurrentSelectedLanguage,
    setShowNoSub
}) {
    const { t } = useTranslation();
    const userToken = useSelector(state => state.organization.userToken);
    const { organization_code } = useSelector(state => state.organization.organizationData);
    const { uuid } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [isLoading, setIsLoading] = useState(false);

    const handleDeleteCancel = () => {
        setDeleteDialogOpen(false);
        setLanguageToDelete(null);
    };

    const handleDeleteConfirm = async () => {
        if (!languageToDelete) return;

        setIsLoading(true);

        try {
            const response = await api({
                method: 'delete',
                url: '/subtitle/delete',
                data: {
                    tk: userToken,
                    uuid: uuid, // 실제 사용 시 비디오 UUID로 대체해야 함
                    ogc: organization_code, // 실제 사용 시 적절한 값으로 대체해야 함
                    lang: languageToDelete.lang
                }
            });
            console.log('sds', response.data)
            if (response.data && response.data.code == 100) {
                // 삭제 성공 처리
                const updatedLanguages = availableSubtitleLanguages.filter(
                    lang => lang.lang !== languageToDelete.lang
                );
                setAvailableSubtitleLanguages(updatedLanguages);

                if (updatedLanguages.length > 0) {
                    // 삭제한 언어가 현재 탭의 언어와 같다면 다른 언어로 변경 && 삭제한 언어가 현재 탭의 언어와 다르면 그대로
                    if (languageToDelete.lang === currentSelectedLanguage.lang) {
                        setCurrentSelectedLanguage(updatedLanguages[0]);
                        const pathSegments = location.pathname.split('/');
                        const subtitleIndex = pathSegments.findIndex(segment => segment === 'subtitle');
                        if (subtitleIndex !== -1) {
                            const newPath = pathSegments.slice(0, subtitleIndex + 1).join('/') + '/' + updatedLanguages[0].lang;
                            navigate(newPath, { replace: true });
                        }
                    }
                } else {
                    const pathSegments = location.pathname.split('/');
                    const subtitleIndex = pathSegments.findIndex(segment => segment === 'subtitle');
                    if (subtitleIndex !== -1) {
                        const newPath = pathSegments.slice(0, subtitleIndex + 1).join('/');
                        navigate(newPath, { replace: true });
                    }
                    setCurrentSelectedLanguage(null);
                    setShowNoSub(true);
                }

                toast.success(t('vod.manage.subtitle_tab.subtitle_deleted'), {
                    position: "top-center",
                    transition: Flip
                });
            } else {
                toast.error(t('vod.manage.subtitle_tab.subtitle_delete_failed'), {
                    position: "top-center",
                    transition: Flip
                });
            }
        } catch (error) {
            toast.error(t('vod.manage.subtitle_tab.subtitle_delete_failed'), {
                position: "top-center",
                transition: Flip
            });
        } finally {
            setDeleteDialogOpen(false);
            setIsLoading(false);
            setLanguageToDelete(null);
        }
    };

    return (
        <Dialog
            open={deleteDialogOpen}
            onClose={handleDeleteCancel}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            disablePortal
        >
            <DialogTitle id="alert-dialog-title">
                {t('vod.manage.subtitle_tab.delete_confirmation_title')}
            </DialogTitle>
            {
                isLoading ?
                    <div style={{ width: '100%', textAlign: 'center', padding: '20px' }}>
                        <div style={{ padding: '10px 0' }}>{t('vod.manage.subtitle_tab.deleting_subtitle')}</div>
                    </div>
                    :
                    <>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {currentSelectedLanguage &&
                                    (t('vod.manage.subtitle_tab.delete_confirmation_message',
                                        { language: t(`languages.${currentSelectedLanguage.lang}`) }) ||
                                        `${t(`languages.${currentSelectedLanguage.lang}`)} ${t('vod.manage.subtitle_tab.delete_confirmation_text')}`)}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleDeleteCancel} color="primary">
                                {t('buttons.cancel')}
                            </Button>
                            <Button onClick={handleDeleteConfirm} color="error" autoFocus>
                                {t('buttons.delete')}
                            </Button>
                        </DialogActions>
                    </>
            }

        </Dialog>
    );
}

export default DeleteSubtitleModal;